export class Helper {
  formatPattern(value, pattern) {
    if (!value) return ''

    let valueIndex = 0
    const list = String(pattern).split('')
    const newList = []

    for (let i = 0; i < pattern.length && valueIndex < value.length; i++) {
      if (list[i] === 'x') {
        newList.push(value[valueIndex++])
      } else newList.push(list[i])
    }

    return newList.join('')
  }

  sleep(ms = 1000) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  isNull(val) {
    return val === null || val === undefined
  }

  notNull(val) {
    return val !== null && val !== undefined
  }

  isValue(val) {
    return val !== null && val !== undefined && val !== ''
  }

  notValue(val) {
    return val === null || val === undefined || val === ''
  }

  isEmpty(val) {
    let list = Object.keys(val)
    return (
      val === null ||
      val === undefined ||
      val === '' ||
      list === 0 ||
      list.length === 0
    )
  }

  toPercent(a, b) {
    if (a === 0 || b === 0) return 0

    return a / b
  }

  toMobile(text) {
    const mobile = (text || '').replaceAll('-', '')
    return this.formatPattern(mobile, 'xxx-xxx-xxxx')
  }

  isTextError(val, text) {
    return val === '' || val === null ? text : undefined
  }

  random({
    len,
    prefix = '',
    postfix = '',
    character = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
  }) {
    let need = len - (prefix.length + postfix.length)
    let max = character.length
    if (need < 0) return
    if (max === 0) return
    let resp = ''

    for (let i = 0; i < need; i++) {
      resp += character.charAt(Math.floor(Math.random() * max))
    }
    return `${prefix}${resp}${postfix}`
  }

  getUrl(val) {
    if (this.isValue(val)) {
      let prefix = val.substring(0, 4)
      if (prefix === 'http' || prefix === 'data') return val
    }

    return undefined
  }

  isUrl(val) {
    if (this.isValue(val)) {
      let prefix = val.substring(0, 4)
      return prefix === 'http'
    }

    return false
  }

  trim(data, list = []) {
    list.forEach((name) => {
      let temp = data[name]
      if (temp) data[name] = temp.trim()
    })

    return data
  }

  upItem(index, list = []) {
    const current = list[index]
    const next = list[index - 1]

    list[index] = next
    list[index - 1] = current
    return list
  }

  downItem(index, list = []) {
    const current = list[index]
    const next = list[index + 1]

    list[index] = next
    list[index + 1] = current
    return list
  }

  compareString(src, target) {
    return (
      String(src).toLocaleLowerCase() === String(target).toLocaleLowerCase()
    )
  }

  searchString(src, target) {
    return String(src)
      .toLocaleLowerCase()
      .includes(String(target).toLocaleLowerCase())
  }

  filterNullObj(obj = {}) {
    const bufferObj = { ...obj }
    for (const [key, value] of Object.entries(bufferObj)) {
      if (this.isNull(value)) delete bufferObj[key]
    }
    return bufferObj
  }
}

export const helper = new Helper()
export default helper
